import React, { useMemo } from 'react';
import { OverrideQuotedRatesContent } from 'components/override-quoted-rates';
import {
  OverrideQuotedRatesPageStore,
  OverrideQuotedRatesPageStoreContext,
} from 'store/pages/override-quoted-rates/pageStore';
import { useParams } from 'react-router-dom';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { NarrowPageWrapperStyled } from '../../globalStyles';

// TESTING_POLICY: CYPRESS_ONLY

const OverrideQuotedRatesPage: React.FC = () => {
  const { periodId, cartId, groupId, portfolioId, productLineId, bcIndex } = useParams<{
    groupId: string;
    periodId: string;
    cartId: string;
    portfolioId: string;
    productLineId: ProductLineId;
    bcIndex: string;
  }>();

  const pageStore = useMemo(
    () =>
      new OverrideQuotedRatesPageStore({
        groupId,
        periodId,
        cartId,
        portfolioId: decodeURIComponent(portfolioId),
        productLineId,
        bcIndex: Number(bcIndex),
      }),
    [],
  );

  return (
    <NarrowPageWrapperStyled>
      <OverrideQuotedRatesPageStoreContext.Provider value={pageStore}>
        <OverrideQuotedRatesContent />
      </OverrideQuotedRatesPageStoreContext.Provider>
    </NarrowPageWrapperStyled>
  );
};

export default OverrideQuotedRatesPage;
